if (!customElements.get('lets-get-real-purity')) {
  customElements.define('lets-get-real-purity', class extends HTMLElement {
    connectedCallback() { this.frame=requestAnimationFrame(()=>this.init()); }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller=new AbortController();
      this.picture=this.querySelector('.lgr-purity__picture');
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.classList.add('is-ready');
      this.observer=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)) { this.classList.add('is-in'); this.observer.disconnect(); }
      },{rootMargin:'0px 0px -12% 0px'});
      this.observer.observe(this);
      const update=()=>{
        this.pending=false;
        if(this.motion.matches) { this.picture.style.removeProperty('--pp'); return; }
        const rect=this.picture.getBoundingClientRect();
        const progress=Math.max(0,Math.min(1,(innerHeight-rect.top)/(innerHeight+rect.height)));
        this.picture.style.setProperty('--pp',progress.toFixed(3));
      };
      const schedule=()=>{if(!this.pending){this.pending=true;this.frame=requestAnimationFrame(update);}};
      const options={signal:this.controller.signal,passive:true};
      window.addEventListener('scroll',schedule,options);
      window.addEventListener('resize',schedule,options);
      this.motion.addEventListener('change',schedule,options);
      update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.pending=false;
      this.controller?.abort(); this.controller=null;
      this.observer?.disconnect(); this.classList.remove('is-ready','is-in');
    }
  });
}